import RecoverStep from "../recover_step";
import {attachSelectableHandler} from "../../utils/recover_utils";

const TEMPLATE = 'rb-export-type';

export default class RbExportType extends RecoverStep {

  constructor() {
    super(TEMPLATE);
  }

  open(data, el, fr, previousStep) {
    fr.render('RbExportType');
  }

  postRender(data, el, fr) {
    attachSelectableHandler(el, (d) => {
      data.recovery.virtualization.type = d.type;
    });
  }
}
